module.exports = {
  context: {
    nodes: [
      {
        id: '100',
        title: 'Privacy Policy',
        url: 'http://adjoin.nitro/privacy-policy'
      }
    ]
  }
}
